export default __webpack_public_path__ + "static/media/elevate-pyl-poster-2.acef7267.jpg";